<template>
  <div class="growthCard-body">
    <div class="image-wrapper">
      <img class="image" :src="imageSrc" :alt="title" />
    </div>
    <div class="text-wrapper">
      <div class="title">{{ title }}</div>
      <div class="text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GrowthCard",
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.growthCard-body {
  width: 820px;
  height: 717px;
  border-radius: 20px;
  background-color: #000000;
}
.image-wrapper {
  width: 100%;
  height: 400px;
  border-radius: 20px 20px 0px 0px;
  overflow: hidden;
}
.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
}

.text-wrapper {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 50px 60px;
  box-sizing: border-box;
  gap: 20px;
}
.title {
  font-size: 35px;
  font-weight: 500;
}
.text {
  font-size: 16px;
  font-weight: 400;
}
.title,
.text {
  color: #ffffff;
}
@media (max-width: 1280px) {
  .growthCard-body {
    width: 596px;
    height: 731px;
  }
  .text {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .growthCard-body {
    width: 468px;
    height: 648px;
  }
  .image-wrapper {
    width: 100%;
    height: 300px;
  }
  .text-wrapper {
    padding: 40px 50px;
  }
  .title {
    font-size: 25px;
  }
  .text {
    font-size: 14px;
  }
}
@media (max-width: 744px) {
  .growthCard-body {
    width: 345px;
    height: 593px;
  }
  .image-wrapper {
    width: 100%;
    height: 260px;
  }
  .text-wrapper {
    padding: 40px;
  }
  .title {
    font-size: 18px;
  }
  .text {
    font-size: 12px;
  }
}
@media (max-width: 588px) {
  .growthCard-body {
    width: 100%;
    min-height: 467px;
    height: fit-content;
  }
  .image-wrapper {
    width: 100%;
    height: 260px;
  }
  .text-wrapper {
    padding: 40px 50px;
  }
}

@media (max-width: 431px) {
  .growthCard-body {
    width: 100%;
    min-height: 483px;
    height: fit-content;
  }
  .image-wrapper {
    width: 100%;
    height: 260px;
  }
  .text-wrapper {
    padding: 30px;
  }
}
</style>
